export default __webpack_public_path__ + "static/media/hortifruti.98e5d7b6.jpg";